import type { Enums } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getMeasurementStatementIcon(
	statement: Enums<"ticketAssignmentMeasurementStatement">,
): IconName {
	switch (statement) {
		case "remember":
			return "BadgeQuestionMark";
		case "without-charge":
			return "BadgeX";
		case "included":
			return "BadgeEuro";
	}
}

export function getMeasurementStatementColor(
	statement: Enums<"ticketAssignmentMeasurementStatement">,
): Enums<"color"> {
	switch (statement) {
		case "remember":
			return "accent";
		case "without-charge":
			return "red";
		case "included":
			return "emerald";
	}
}
